<ejs-dialog id="component-dialog" cssClass="viewer-in-dialog" #Dialog showCloseIcon='true' width='80%' height="95%"
  (close)="closeDialoge()" [enableResize]=true [visible]="true" [isModal]=''>
  <ng-template #content>
    <ejs-pdfviewer id="pdfviewer" class="pdfViewer" [resourceUrl]='resource'></ejs-pdfviewer>
  </ng-template>
</ejs-dialog>